// src/pages/SignIn/index.jsx
import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import styles from "./signin.module.css";
import logo from '../../assets/logo.png';

export default function SignIn() {
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const { signIn, loadingAuth, user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Se já estiver autenticado, redireciona para a área protegida
  useEffect(() => {
    if (user) {
      navigate("/Vendas", { replace: true });
    }
  }, [user, navigate]);

  async function handleSignIn(e) {
    e.preventDefault();
    if (loadingAuth) return;
    const loginTrim = login.trim();
    const senhaTrim = senha.trim();
    if (loginTrim === "" || senhaTrim === "") {
      setErrorMsg("Preencha login e senha.");
      return;
    }

    const { success, message } = await signIn(loginTrim, senhaTrim);
    if (success) {
      navigate("/Dashboard", { replace: true });
    } else {
      setErrorMsg(message);
    }
  }

  return (
    <main className={`${styles.root} ${styles["container-center"]}`}>
      <div className={styles.login}>
        <div className={styles["login-area"]}>
          <img src={logo} alt="Logo do sistema" />
        </div>

        <form onSubmit={handleSignIn} className={styles["user-form"]} noValidate>
          <h1>Entrar</h1>
          {errorMsg && <p className="error-text">{errorMsg}</p>}

          <label htmlFor="login" className="sr-only">Login</label>
          <input
            id="login"
            name="login"
            type="text"
            placeholder="Seu login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            autoComplete="username"
            required
            disabled={loadingAuth}
            aria-invalid={Boolean(errorMsg) && login.trim() === ""}
          />

          <label htmlFor="senha" className="sr-only">Senha</label>
          <input
            id="senha"
            name="senha"
            type="password"
            placeholder="********"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password"
            required
            disabled={loadingAuth}
            aria-invalid={Boolean(errorMsg) && senha.trim() === ""}
          />

          <button type="submit" disabled={loadingAuth}>
            {loadingAuth ? "Carregando..." : "Acessar"}
          </button>
        </form>

        {/*<Link to="/signup">Ainda não possui conta? Cadastre-se</Link>*/}
      </div>
    </main>
  );
}
